import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="footer" data-testid="footer">
      <div className="container-main">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <Link to="/" className="inline-block mb-6">
              <img
                src="/logo.svg"
                alt="Averoan"
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-white/60 max-w-sm leading-relaxed mb-6">
              We help businesses grow through stunning websites, powerful software,
              and strategic marketing that delivers results.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 text-sm font-medium hover:text-[#D4FF00] transition-colors"
              style={{ color: '#A1A1AA' }}
            >
              Start a project <ArrowUpRight size={14} />
            </Link>
          </div>

          <div className="md:col-span-2 md:col-start-7">
            <h4 className="text-xs font-bold mb-6 uppercase tracking-wider" style={{ color: '#D4FF00' }}>
              Navigation
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/about">About</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-bold mb-6 uppercase tracking-wider" style={{ color: '#D4FF00' }}>
              Services
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/services/web-development">Web Development</Link></li>
              <li><Link to="/services/custom-software">Custom Software</Link></li>
              <li><Link to="/services/growth-marketing">Marketing</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/launch" style={{ color: '#D4FF00' }}>$500 Website Offer</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-bold mb-6 uppercase tracking-wider" style={{ color: '#D4FF00' }}>
              Contact
            </h4>
            <ul className="space-y-3 text-sm">
              <li><a href="mailto:info@averoan.com">info@averoan.com</a></li>
              <li><a href="tel:+17787887273">(778) 788-7273</a></li>
              <li><Link to="/consultation">Free Consultation</Link></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 pt-8 border-t border-white/5">
          <p className="text-xs" style={{ color: '#A1A1AA' }}>
            © {new Date().getFullYear()} Averoan Technologies Inc. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs" style={{ color: '#A1A1AA' }}>
            <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
